
// define some steps messages
const buildStep = (current, title, description, extra) => `
<div>
  <div class="font-[Inter] mt-2.5 text-2xl font-semibold text-[#073B5D] ${(!current) ? '-mt-1.5' : ''}">${title}</div>
  <div class="font-[Inter] mt-2.5 text-sm font-normal text-[#323232]">${description}</div>
  ${extra ? `<div class="font-[Inter] mt-2.5 font-normal text-sm text-[#323232]">${extra}</div>` : ''}
</div>
`
const actionMessage = (reason = '<span class="mr-1">messages</span>') => `
<div class="flex flex-wrap text-sm won-blue">
  <span
      class="flex items-center px-1 rounded-md won-tag-light-gray mr-1"
  >
      Edit
      <svg
          class="ml-0.5 w-4 h-4"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
              d="M3 17.2505V21.0005H6.75L17.81 9.94055L14.06 6.19055L3 17.2505ZM20.71 7.04055C21.1 6.65055 21.1 6.02055 20.71 5.63055L18.37 3.29055C17.98 2.90055 17.35 2.90055 16.96 3.29055L15.13 5.12055L18.88 8.87055L20.71 7.04055Z"
              fill="#656E83"
          />
      </svg>
  </span>
  <span class="mr-1">and/or</span>
  <span
      class="flex items-center px-1 rounded-md won-tag-light-gray mr-1"
  >
      regenerate
      <svg
          class="ml-0.5 w-4 h-4"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
              d="M17.6498 6.35C16.1998 4.9 14.2098 4 11.9998 4C7.57977 4 4.00977 7.58 4.00977 12C4.00977 16.42 7.57977 20 11.9998 20C15.7298 20 18.8398 17.45 19.7298 14H17.6498C16.8298 16.33 14.6098 18 11.9998 18C8.68977 18 5.99977 15.31 5.99977 12C5.99977 8.69 8.68977 6 11.9998 6C13.6598 6 15.1398 6.69 16.2198 7.78L12.9998 11H19.9998V4L17.6498 6.35Z"
              fill="#656E83"
          />
      </svg>
  </span>
  <span class="mr-1">the</span>
  ${reason}
  <span class="mr-1">we've</span>
  <span class="mr-1">generated</span>
  <span class="mr-1">until</span>
  <span class="mr-1">it's</span>
  <span class="mr-1">ready</span>
  <span class="mr-1">to</span>
  <span class="mr-1">be</span>
  <span
      class="flex items-center px-1 rounded-md won-tag-light-gray mr-1"
  >
      copied
      <svg
          class="ml-0.5 w-4 h-4"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
              d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
              fill="#656E83"
          />
      </svg>
  </span>
  <span class="mr-1">and</span>
  <span class="mr-1">used.</span>
</div>
`
const purchaseMessage = () => `
<div class="flex flex-wrap text-sm won-blue">
<span class="mr-1">We</span>
<span class="mr-1">give</span>
<span class="mr-1">everyone</span>
<span class="mr-1">10</span>
<span class="mr-1">free</span>
<span class="mr-1">tokens</span>
<span class="mr-1">so</span>
<span class="mr-1">you</span>
<span class="mr-1">can</span>
<span class="mr-1">improve</span>
<span class="mr-1">your</span>
<span class="mr-1">resume</span>
<span class="mr-1">for</span>
<span class="mr-1">free!</span>
<span class="mr-1">That</span>
<span class="mr-1">means</span>
<span class="mr-1">you</span>
<span class="mr-1">can</span>
<span class="mr-1 font-semibold">generate</span>
<span class="mr-1 font-semibold">new</span>
<span class="mr-1 font-semibold">bullet</span>
<span class="mr-1 font-semibold">points</span>
<span class="mr-1 font-semibold">10</span>
<span class="mr-1 font-semibold">times.</span>
<span class="mr-1">Don't</span>
<span class="mr-1">worry,</span>
<span class="mr-1">you</span>
<span class="mr-1">can</span>
<span class="mr-1">always</span>
<span class="mr-1">buy</span>
<span class="mr-1">more</span>
<span class="mr-1">by</span>
<span class="mr-1">clicking</span>
<span class="flex items-center px-1 rounded-md won-tag-light-gray mr-1 font-medium">
  <svg class="ml-0.5 w-4 h-4" width="16" height="16" viewBox="0 0 16 16" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99967 13.332C5.05967 13.332 2.66634 10.9387 2.66634 7.9987C2.66634 5.0587 5.05967 2.66536 7.99967 2.66536C10.9397 2.66536 13.333 5.0587 13.333 7.9987C13.333 10.9387 10.9397 13.332 7.99967 13.332ZM7.99967 14.6654C11.6797 14.6654 14.6663 11.6787 14.6663 7.9987C14.6663 4.3187 11.6797 1.33203 7.99967 1.33203C4.31967 1.33203 1.33301 4.3187 1.33301 7.9987C1.33301 11.6787 4.31967 14.6654 7.99967 14.6654ZM7.33301 7.9987V10.6654H8.66634V7.9987H10.6663L7.99967 5.33203L5.33301 7.9987H7.33301Z"
      fill="#656E83" />
  </svg>
  Buy tokens
</span>
<span class="mr-1">or</span>
<span class="flex items-center px-1 rounded-md won-tag-light-gray mr-1 font-medium">
  <svg class="ml-0.5 w-4 h-4" width="16" height="16" viewBox="0 0 16 16" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7597 8.62823C12.7864 8.42823 12.7997 8.22156 12.7997 8.00156C12.7997 7.78823 12.7864 7.5749 12.7531 7.3749L14.1064 6.32156C14.2264 6.22823 14.2597 6.04823 14.1864 5.9149L12.9064 3.70156C12.8264 3.5549 12.6597 3.50823 12.5131 3.5549L10.9197 4.1949C10.5864 3.94156 10.2331 3.72823 9.83975 3.56823L9.59975 1.8749C9.57308 1.7149 9.43975 1.60156 9.27975 1.60156H6.71975C6.55975 1.60156 6.43308 1.7149 6.40641 1.8749L6.16641 3.56823C5.77308 3.72823 5.41308 3.94823 5.08641 4.1949L3.49308 3.5549C3.34641 3.50156 3.17975 3.5549 3.09975 3.70156L1.82641 5.9149C1.74641 6.0549 1.77308 6.22823 1.90641 6.32156L3.25975 7.3749C3.22641 7.5749 3.19975 7.7949 3.19975 8.00156C3.19975 8.20823 3.21308 8.42823 3.24641 8.62823L1.89308 9.68156C1.77308 9.7749 1.73975 9.9549 1.81308 10.0882L3.09308 12.3016C3.17308 12.4482 3.33975 12.4949 3.48641 12.4482L5.07975 11.8082C5.41308 12.0616 5.76641 12.2749 6.15975 12.4349L6.39975 14.1282C6.43308 14.2882 6.55975 14.4016 6.71975 14.4016H9.27975C9.43975 14.4016 9.57308 14.2882 9.59308 14.1282L9.83308 12.4349C10.2264 12.2749 10.5864 12.0616 10.9131 11.8082L12.5064 12.4482C12.6531 12.5016 12.8197 12.4482 12.8997 12.3016L14.1797 10.0882C14.2597 9.94156 14.2264 9.7749 14.0997 9.68156L12.7597 8.62823ZM7.99975 10.4016C6.67975 10.4016 5.59975 9.32156 5.59975 8.00156C5.59975 6.68156 6.67975 5.60156 7.99975 5.60156C9.31975 5.60156 10.3997 6.68156 10.3997 8.00156C10.3997 9.32156 9.31975 10.4016 7.99975 10.4016Z"
      fill="#656E83" />
  </svg>

  Settings > Billing
</span>
</div>

`
const editAction = () => `
<div class="inline-block">
  <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
            Edit <svg class="ml-0.5 w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M3 17.2505V21.0005H6.75L17.81 9.94055L14.06 6.19055L3 17.2505ZM20.71 7.04055C21.1 6.65055 21.1 6.02055 20.71 5.63055L18.37 3.29055C17.98 2.90055 17.35 2.90055 16.96 3.29055L15.13 5.12055L18.88 8.87055L20.71 7.04055Z" fill="#656E83" /> </svg>
  </span>
</div>
`
const removeAction = () => `
<div class="inline-block">
  <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
            remove <svg class="ml-0.5 w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1414_62584)">
            <path d="M4.00004 12.6667C4.00004 13.4 4.60004 14 5.33337 14L10.6667 14C11.4 14 12 13.4 12 12.6667L12 4.66667L4.00004 4.66667L4.00004 12.6667ZM5.33337 6L10.6667 6V12.6667L5.33337 12.6667L5.33337 6ZM10.3334 2.66667L9.66671 2L6.33337 2L5.66671 2.66667L3.33337 2.66667L3.33337 4L12.6667 4V2.66667H10.3334Z" fill="#EB5757"/>
            </g>
            <defs>
            <clipPath id="clip0_1414_62584">
            <rect class="ml-0.5 w-4 h-4" fill="white"/>
            </clipPath>
            </defs>
            </svg>
  </span>
</div>
`
const reorderAction = () => `
<div class="inline-block">
  <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
            reorder <svg class="ml-0.5 w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1414_62577)">
            <path d="M7.33329 12C7.33329 12.7333 6.73329 13.3333 5.99996 13.3333C5.26663 13.3333 4.66663 12.7333 4.66663 12C4.66663 11.2666 5.26663 10.6666 5.99996 10.6666C6.73329 10.6666 7.33329 11.2666 7.33329 12ZM5.99996 6.66663C5.26663 6.66663 4.66663 7.26663 4.66663 7.99996C4.66663 8.73329 5.26663 9.33329 5.99996 9.33329C6.73329 9.33329 7.33329 8.73329 7.33329 7.99996C7.33329 7.26663 6.73329 6.66663 5.99996 6.66663ZM5.99996 2.66663C5.26663 2.66663 4.66663 3.26663 4.66663 3.99996C4.66663 4.73329 5.26663 5.33329 5.99996 5.33329C6.73329 5.33329 7.33329 4.73329 7.33329 3.99996C7.33329 3.26663 6.73329 2.66663 5.99996 2.66663ZM9.99996 5.33329C10.7333 5.33329 11.3333 4.73329 11.3333 3.99996C11.3333 3.26663 10.7333 2.66663 9.99996 2.66663C9.26663 2.66663 8.66663 3.26663 8.66663 3.99996C8.66663 4.73329 9.26663 5.33329 9.99996 5.33329ZM9.99996 6.66663C9.26663 6.66663 8.66663 7.26663 8.66663 7.99996C8.66663 8.73329 9.26663 9.33329 9.99996 9.33329C10.7333 9.33329 11.3333 8.73329 11.3333 7.99996C11.3333 7.26663 10.7333 6.66663 9.99996 6.66663ZM9.99996 10.6666C9.26663 10.6666 8.66663 11.2666 8.66663 12C8.66663 12.7333 9.26663 13.3333 9.99996 13.3333C10.7333 13.3333 11.3333 12.7333 11.3333 12C11.3333 11.2666 10.7333 10.6666 9.99996 10.6666Z" fill="#A1AEB7"/>
            </g>
            <defs>
            <clipPath id="clip0_1414_62577">
            <rect class="ml-0.5 w-4 h-4" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            
  </span>
</div>
`
const addAction = () => `
<div class="inline-block">
  <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
      add <svg class="ml-0.5 w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1414_62580)">
      <path d="M7.99992 1.33337C4.31992 1.33337 1.33325 4.32004 1.33325 8.00004C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.6799 1.33337 7.99992 1.33337ZM11.3333 8.66671H8.66659V11.3334L7.33325 11.3334V8.66671H4.66659V7.33337L7.33325 7.33337L7.33325 4.66671H8.66659V7.33337H11.3333L11.3333 8.66671Z" fill="#A1AEB7"/>
      </g>
      <defs>
      <clipPath id="clip0_1414_62580">
      <rect class="ml-0.5 w-4 h-4" fill="white"/>
      </clipPath>
      </defs>
      </svg>
      
  </span>
</div>
`
const generatePointsAction = () => `
<div class="inline-block">
  <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
  Generate Points <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1414_62029)">
            <path d="M12.6667 6.00008L13.5 4.16675L15.3334 3.33341L13.5 2.50008L12.6667 0.666748L11.8334 2.50008L10 3.33341L11.8334 4.16675L12.6667 6.00008ZM7.66669 6.33341L6.00002 2.66675L4.33335 6.33341L0.666687 8.00008L4.33335 9.66675L6.00002 13.3334L7.66669 9.66675L11.3334 8.00008L7.66669 6.33341ZM12.6667 10.0001L11.8334 11.8334L10 12.6667L11.8334 13.5001L12.6667 15.3334L13.5 13.5001L15.3334 12.6667L13.5 11.8334L12.6667 10.0001Z" fill="#A1AEB7"/>
            </g>
            <defs>
            <clipPath id="clip0_1414_62029">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
            </svg>
  </span>
</div>
`
const addBulletPointAction = () => `
<div class="inline-block">
<span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1414_61010)">
<path d="M7.99998 1.33337C4.31998 1.33337 1.33331 4.32004 1.33331 8.00004C1.33331 11.68 4.31998 14.6667 7.99998 14.6667C11.68 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.68 1.33337 7.99998 1.33337ZM11.3333 8.66671H8.66665V11.3334H7.33331V8.66671H4.66665V7.33337H7.33331V4.66671H8.66665V7.33337H11.3333V8.66671Z" fill="#A1AEB7"/>
</g>
<defs>
<clipPath id="clip0_1414_61010">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
</span>
</div>
`
const keyboardCommandsAction = () => `
  <div class="grid grid-cols-3 gap-3 divide-x mt-8">
    <div class="flex flex-col w-full items-center space-y-1">
      <div class="flex flex-row items-center gap-2">
        <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="37" height="37" rx="4" fill="#F4F4F4"/><path d="M27.481 23.5826L27.4512 23.3126L27.4072 23.0622L27.3513 22.8352L27.279 22.613L27.1927 22.4027L27.0915 22.2041L26.9761 22.0174L26.8465 21.843L26.7027 21.681L26.5459 21.5324L26.3758 21.3972L26.1936 21.2763L25.9993 21.1694L25.793 21.0771L25.5748 20.9995L25.3359 20.9343L25.0915 20.8864L24.8297 20.8526L24.6278 20.837V20.8259L21.5249 20.8258V16.1746H24.2781L24.6278 16.174V16.1636L24.8364 16.1474L25.0992 16.1129L25.3442 16.0641L25.5664 16.0037L25.7846 15.9267L25.9908 15.8353L26.1854 15.7293L26.3682 15.609L26.5384 15.4748L26.696 15.3266L26.84 15.1655L26.9704 14.9915L27.0868 14.8047L27.1888 14.6065L27.2761 14.3962L27.3489 14.174L27.4092 13.9305L27.4526 13.6807L27.4817 13.4117L27.5 12.8373L27.4936 12.4655L27.4812 12.2566L27.4513 11.9867L27.4074 11.7363L27.3514 11.5093L27.2792 11.287L27.1928 11.0768L27.0917 10.8781L26.9763 10.6914L26.8467 10.5171L26.7029 10.3551L26.546 10.2065L26.376 10.0713L26.1936 9.95035L25.9993 9.84376L25.793 9.7514L25.5749 9.67383L25.3359 9.60868L25.0915 9.56069L24.8297 9.52693L24.5409 9.50698L24.161 9.5L24.0042 9.50084L23.678 9.512L23.399 9.53725L23.143 9.57645L22.9031 9.63003L22.6766 9.69797L22.4706 9.77693L22.2682 9.87334L22.078 9.98355L21.8994 10.1086L21.7333 10.2475L21.58 10.4003L21.4403 10.5659L21.3145 10.7443L21.2029 10.9347L21.1056 11.1372L21.023 11.3516L20.953 11.5863L20.9003 11.8257L20.8616 12.0813L20.8371 12.3593L20.8255 12.8376L20.8267 12.9052L20.8258 15.4755L16.1744 15.4752L16.1734 12.911L16.1746 12.8373L16.1682 12.4655L16.1557 12.2562L16.1258 11.9864L16.0819 11.7363L16.0234 11.501L15.9537 11.287L15.8669 11.0766L15.7659 10.8783L15.6502 10.6915L15.5206 10.5168L15.3775 10.3552L15.2205 10.2064L15.0508 10.0713L14.868 9.95022L14.6737 9.84363L14.4673 9.75128L14.2493 9.67371L14.0103 9.60856L13.7659 9.56042L13.504 9.52666L13.2153 9.50671L12.8356 9.50001L12.6787 9.50085L12.3525 9.51201L12.0738 9.53726L11.8178 9.57647L11.5778 9.63004L11.3514 9.69798L11.1454 9.77694L10.9429 9.87335L10.7524 9.98398L10.5739 10.1086L10.4078 10.2477L10.2546 10.4003L10.115 10.5659L9.98926 10.744L9.87765 10.9346L9.78041 11.1371L9.69504 11.3594L9.62779 11.5856L9.57478 11.8254L9.53614 12.0809L9.51158 12.3589L9.5 12.8373L9.50642 13.2091L9.51898 13.4184L9.54883 13.6882L9.59278 13.9384L9.65123 14.1736L9.72099 14.3876L9.80762 14.5978L9.90862 14.7962L10.0243 14.983L10.1539 15.1577L10.2973 15.3195L10.454 15.4683L10.624 15.6034L10.8062 15.7244L11.0006 15.8313L11.2069 15.9236L11.4251 16.0012L11.6639 16.0663L11.9083 16.1143L12.1702 16.1481L12.3721 16.1637V16.1747H15.4749V20.826L12.722 20.8261L12.3722 20.8267V20.8371L12.0737 20.8634L11.8178 20.9026L11.5778 20.9561L11.3596 21.0213L11.1456 21.103L10.9432 21.1994L10.7526 21.3101L10.5739 21.4345L10.4078 21.5735L10.2547 21.7258L10.1151 21.8914L9.98926 22.0699L9.87765 22.2606L9.78041 22.463L9.69503 22.6854L9.62765 22.9118L9.57464 23.1516L9.53599 23.4071L9.51144 23.6851L9.5 24.1633L9.50642 24.5351L9.51897 24.7443L9.54883 25.0142L9.59277 25.2643L9.65123 25.4995L9.72098 25.7135L9.80762 25.9238L9.90862 26.1222L10.0243 26.309L10.1539 26.4836L10.2973 26.6455L10.4541 26.7941L10.6242 26.9293L10.8065 27.0502L11.0008 27.1568L11.2072 27.2492L11.4252 27.3267L11.6642 27.3919L11.9086 27.4399L12.1705 27.4736L12.4592 27.4936L12.8373 27.5L12.9957 27.4992L13.3218 27.488L13.6006 27.4627L13.8566 27.4235L14.0965 27.37L14.3227 27.302L14.5287 27.2231L14.7311 27.1267L14.9217 27.016L15.1006 26.8909L15.2666 26.7521L15.4198 26.5994L15.5591 26.434L15.685 26.2555L15.7966 26.065L15.8938 25.8625L15.9764 25.6481L16.0464 25.4137L16.0994 25.1739L16.1381 24.9185L16.1626 24.6404L16.1742 24.1621L16.173 24.0945L16.1739 21.5242H20.825L20.826 24.0885L20.8247 24.1621L20.8311 24.5339L20.8437 24.7432L20.8735 25.013L20.9175 25.2635L20.9759 25.4984L21.0457 25.7124L21.1325 25.9226L21.2335 26.121L21.3488 26.3077L21.4786 26.4824L21.622 26.6442L21.7788 26.7928L21.9489 26.9278L22.1312 27.0491L22.3255 27.1557L22.5319 27.248L22.7499 27.3256L22.9889 27.3907L23.2333 27.4389L23.4952 27.4726L23.784 27.4926L24.1617 27.499L24.3204 27.4982L24.5458 27.4922L24.8356 27.4718L25.098 27.4373L25.3432 27.3885L25.5655 27.3281L25.7837 27.2511L25.9899 27.1597L26.1845 27.0537L26.3672 26.9334L26.5374 26.7992L26.6951 26.6512L26.8393 26.49L26.9698 26.3161L27.0861 26.1293L27.1881 25.931L27.2754 25.7208L27.3483 25.4985L27.4085 25.2551L27.4519 25.0052L27.4811 24.7362L27.4998 24.1632L27.4933 23.7914L27.481 23.5826ZM21.531 12.4833L21.5481 12.2397L21.5763 12.0215L21.615 11.8237L21.6654 11.6382L21.7248 11.4706L21.794 11.3152L21.8726 11.1713L21.9606 11.0381L22.0578 10.9153L22.1644 10.8023L22.2806 10.6989L22.407 10.6048L22.5435 10.52L22.6911 10.4446L22.8507 10.3786L23.0793 10.3071L23.2716 10.2641L23.4829 10.2317L23.7209 10.2104L24.1615 10.1998L24.4155 10.2024L24.6817 10.2158L24.9084 10.24L25.1124 10.2754L25.299 10.3211L25.4754 10.3785L25.6346 10.4445L25.7822 10.5198L25.9186 10.6046L26.0448 10.6988L26.1611 10.8022L26.2676 10.9152L26.3649 11.0382L26.4526 11.1711L26.5315 11.315L26.6005 11.4702L26.6777 11.6974L26.7358 11.9459L26.7682 12.1576L26.7895 12.3952L26.8001 12.8374L26.7942 13.1912L26.7841 13.3563L26.7596 13.5833L26.7244 13.7871L26.6777 13.9779L26.6214 14.15L26.5555 14.3094L26.4801 14.4567L26.3956 14.5932L26.3014 14.7194L26.1978 14.8357L26.0847 14.9422L25.962 15.0395L25.8288 15.1275L25.6849 15.2061L25.5295 15.2753L25.3617 15.3347L25.1203 15.3975L24.9157 15.4335L24.6881 15.4587L24.421 15.4725L21.5252 15.4753L21.5262 12.8992L21.5252 12.8374L21.531 12.4833ZM15.475 15.4752H12.8334L12.4894 15.4693L12.2395 15.4522L12.0213 15.424L11.8238 15.3852L11.638 15.3346L11.4704 15.2751L11.315 15.2059L11.1712 15.1274L11.0379 15.0394L10.9152 14.9421L10.8022 14.8355L10.6985 14.7193L10.6043 14.5931L10.5195 14.4566L10.4442 14.309L10.3782 14.1494L10.3066 13.921L10.2637 13.7288L10.2313 13.5174L10.21 13.2794L10.1993 12.8371L10.2053 12.4832L10.2224 12.2396L10.2505 12.0213L10.2893 11.8239L10.34 11.6379L10.3994 11.4703L10.4686 11.3152L10.5471 11.1712L10.6352 11.0383L10.7324 10.9155L10.839 10.8025L10.9552 10.6991L11.0815 10.6049L11.2179 10.5201L11.3655 10.4448L11.5251 10.3788L11.7538 10.3072L11.946 10.2642L12.1574 10.2319L12.3954 10.2105L12.8359 10.1999L13.1853 10.2058L13.4351 10.2229L13.6534 10.2511L13.8508 10.2899L14.0368 10.3405L14.2042 10.4L14.3596 10.4692L14.5036 10.5477L14.6366 10.6355L14.7593 10.7327L14.8723 10.8393L14.9757 10.9555L15.0699 11.0818L15.1547 11.2182L15.2303 11.3658L15.2963 11.525L15.3679 11.7538L15.4108 11.9461L15.4432 12.1574L15.4645 12.3954L15.4751 12.8378L15.4739 12.9055L15.475 15.4752ZM15.469 24.5169L15.452 24.7605L15.4238 24.9788L15.385 25.1762L15.3344 25.3621L15.2749 25.5296L15.2057 25.685L15.1272 25.829L15.0392 25.962L14.9419 26.0848L14.8354 26.1978L14.7191 26.3011L14.5929 26.3953L14.4566 26.4804L14.309 26.5557L14.1494 26.6217L13.9207 26.6933L13.7285 26.7363L13.5171 26.7686L13.2791 26.79L12.8369 26.8006L12.4891 26.7947L12.2392 26.7776L12.0209 26.7494L11.8235 26.7106L11.6375 26.66L11.4701 26.6005L11.3147 26.5313L11.1707 26.4528L11.0378 26.3648L10.915 26.2675L10.802 26.1609L10.6986 26.0447L10.6045 25.9184L10.5197 25.782L10.4443 25.6344L10.3783 25.4748L10.3068 25.2461L10.2638 25.0539L10.2314 24.8425L10.2101 24.6045L10.1995 24.1623L10.2055 23.8083L10.2155 23.6437L10.2401 23.4164L10.2752 23.2126L10.321 23.0259L10.3783 22.8497L10.4442 22.6905L10.5195 22.5429L10.6043 22.4065L10.6985 22.2802L10.8022 22.164L10.9152 22.0574L11.0379 21.9602L11.1712 21.8721L11.315 21.7936L11.4704 21.7244L11.6382 21.665L11.8796 21.6022L12.0842 21.5662L12.3118 21.5409L12.5789 21.5271L15.4747 21.5243L15.4737 24.1004L15.4747 24.1623L15.469 24.5169ZM16.1746 20.8254L16.1745 16.1742H20.8256V20.8254H16.1746ZM26.7942 24.5169L26.7842 24.6819L26.7596 24.9089L26.7245 25.1128L26.6778 25.3036L26.6007 25.5302L26.5317 25.6853L26.4529 25.8293L26.3651 25.9621L26.2679 26.0852L26.1613 26.1982L26.0451 26.3016L25.9188 26.3957L25.7818 26.4804L25.6342 26.5558L25.4746 26.6217L25.246 26.6933L25.054 26.7363L24.8427 26.7687L24.6047 26.79L24.1623 26.8006L23.8145 26.7947L23.5646 26.7776L23.3463 26.7494L23.1489 26.7106L22.9629 26.66L22.7955 26.6005L22.6401 26.5313L22.4961 26.4528L22.3632 26.365L22.2401 26.2678L22.1271 26.1612L22.0237 26.045L21.9296 25.9187L21.8448 25.7822L21.7694 25.6346L21.7034 25.4751L21.6319 25.2464L21.5889 25.054L21.5565 24.8428L21.5352 24.6048L21.5246 24.1624L21.5258 24.0947L21.5249 21.5246H24.1663L24.4151 21.5273L24.6812 21.5407L24.9085 21.5652L25.1125 21.6007L25.2991 21.6464L25.4753 21.7036L25.6348 21.7696L25.7824 21.8452L25.919 21.93L26.0452 22.0242L26.1614 22.1276L26.2683 22.2407L26.3655 22.3638L26.4533 22.4966L26.5321 22.6406L26.6012 22.7957L26.6783 23.023L26.7365 23.2715L26.7688 23.4831L26.7902 23.7207L26.8008 24.163L26.7942 24.5169Z" fill="#444C58" stroke="#444C58" stroke-width="0.75"/></svg>
        <span class="font-[Inter] font-normal text-base text-[#444C58] text-center">+</span>
        <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="37" height="37" rx="4" fill="#F4F4F4"/><path d="M13.2784 25.5V24.2216L21.1193 12.517H13.1932V10.9545H23.2216V12.233L15.3807 23.9375H23.3068V25.5H13.2784Z" fill="#444C58"/></svg>
      </div>
      <span class="font-[Inter] italic font-normal text-xs text-[#073B5D]">Cmd/Ctrl + Z</span>
      <span class="font-[Inter] font-semibold text-sm text-[#2A8176]">Undo</span>
    </div>
    <div class="flex flex-col w-full items-center space-y-1">
      <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="37" height="37" rx="4" fill="#F4F4F4"/><path d="M9.88636 24.1818C9.04545 24.1818 8.32008 23.9962 7.71023 23.625C7.10417 23.25 6.63636 22.7273 6.30682 22.0568C5.98106 21.3826 5.81818 20.5985 5.81818 19.7045C5.81818 18.8106 5.98106 18.0227 6.30682 17.3409C6.63636 16.6553 7.0947 16.1212 7.68182 15.7386C8.27273 15.3523 8.96212 15.1591 9.75 15.1591C10.2045 15.1591 10.6534 15.2348 11.0966 15.3864C11.5398 15.5379 11.9432 15.7841 12.3068 16.125C12.6705 16.4621 12.9602 16.9091 13.1761 17.4659C13.392 18.0227 13.5 18.7083 13.5 19.5227V20.0909H6.77273V18.9318H12.1364C12.1364 18.4394 12.0379 18 11.8409 17.6136C11.6477 17.2273 11.3712 16.9223 11.0114 16.6989C10.6553 16.4754 10.2348 16.3636 9.75 16.3636C9.21591 16.3636 8.75379 16.4962 8.36364 16.7614C7.97727 17.0227 7.67992 17.3636 7.47159 17.7841C7.26326 18.2045 7.15909 18.6553 7.15909 19.1364V19.9091C7.15909 20.5682 7.27273 21.1269 7.5 21.5852C7.73106 22.0398 8.05114 22.3864 8.46023 22.625C8.86932 22.8598 9.3447 22.9773 9.88636 22.9773C10.2386 22.9773 10.5568 22.928 10.8409 22.8295C11.1288 22.7273 11.3769 22.5758 11.5852 22.375C11.7936 22.1705 11.9545 21.9167 12.0682 21.6136L13.3636 21.9773C13.2273 22.4167 12.9981 22.803 12.6761 23.1364C12.3542 23.4659 11.9564 23.7235 11.483 23.9091C11.0095 24.0909 10.4773 24.1818 9.88636 24.1818ZM21.7216 17.2273L20.517 17.5682C20.4413 17.3674 20.3295 17.1723 20.1818 16.983C20.0379 16.7898 19.8409 16.6307 19.5909 16.5057C19.3409 16.3807 19.0208 16.3182 18.6307 16.3182C18.0966 16.3182 17.6515 16.4413 17.2955 16.6875C16.9432 16.9299 16.767 17.2386 16.767 17.6136C16.767 17.947 16.8883 18.2102 17.1307 18.4034C17.3731 18.5966 17.7519 18.7576 18.267 18.8864L19.5625 19.2045C20.3428 19.3939 20.9242 19.6837 21.3068 20.0739C21.6894 20.4602 21.8807 20.9583 21.8807 21.5682C21.8807 22.0682 21.7367 22.5152 21.4489 22.9091C21.1648 23.303 20.767 23.6136 20.2557 23.8409C19.7443 24.0682 19.1496 24.1818 18.4716 24.1818C17.5814 24.1818 16.8447 23.9886 16.2614 23.6023C15.678 23.2159 15.3087 22.6515 15.1534 21.9091L16.4261 21.5909C16.5473 22.0606 16.7765 22.4129 17.1136 22.6477C17.4545 22.8826 17.8996 23 18.4489 23C19.0739 23 19.5701 22.8674 19.9375 22.6023C20.3087 22.3333 20.4943 22.0114 20.4943 21.6364C20.4943 21.3333 20.3883 21.0795 20.1761 20.875C19.964 20.6667 19.6383 20.5114 19.1989 20.4091L17.7443 20.0682C16.9451 19.8788 16.358 19.5852 15.983 19.1875C15.6117 18.786 15.4261 18.2841 15.4261 17.6818C15.4261 17.1894 15.5644 16.7538 15.8409 16.375C16.1212 15.9962 16.5019 15.6989 16.983 15.483C17.4678 15.267 18.017 15.1591 18.6307 15.1591C19.4943 15.1591 20.1723 15.3485 20.6648 15.7273C21.161 16.1061 21.5133 16.6061 21.7216 17.2273ZM27.4446 24.1818C26.6264 24.1818 25.9219 23.9886 25.331 23.6023C24.7401 23.2159 24.2855 22.6837 23.9673 22.0057C23.6491 21.3277 23.4901 20.553 23.4901 19.6818C23.4901 18.7955 23.6529 18.0133 23.9787 17.3352C24.3082 16.6534 24.7666 16.1212 25.3537 15.7386C25.9446 15.3523 26.634 15.1591 27.4219 15.1591C28.0355 15.1591 28.5885 15.2727 29.081 15.5C29.5734 15.7273 29.9768 16.0455 30.2912 16.4545C30.6056 16.8636 30.8007 17.3409 30.8764 17.8864H29.5355C29.4332 17.4886 29.206 17.1364 28.8537 16.8295C28.5052 16.5189 28.0355 16.3636 27.4446 16.3636C26.9219 16.3636 26.4635 16.5 26.0696 16.7727C25.6795 17.0417 25.3745 17.4223 25.1548 17.9148C24.9389 18.4034 24.831 18.9773 24.831 19.6364C24.831 20.3106 24.937 20.8977 25.1491 21.3977C25.3651 21.8977 25.6681 22.286 26.0582 22.5625C26.4522 22.839 26.9143 22.9773 27.4446 22.9773C27.7931 22.9773 28.1094 22.9167 28.3935 22.7955C28.6776 22.6742 28.9181 22.5 29.1151 22.2727C29.312 22.0455 29.4522 21.7727 29.5355 21.4545H30.8764C30.8007 21.9697 30.6132 22.4337 30.3139 22.8466C30.0185 23.2557 29.6264 23.5814 29.1378 23.8239C28.6529 24.0625 28.0885 24.1818 27.4446 24.1818Z" fill="#444C58"/></svg>
      <span class="font-[Inter] italic font-normal text-xs text-[#073B5D]">during edit mode</span>
      <span class="font-[Inter] font-semibold text-sm text-[#2A8176]">Exit edit mode</span>
    </div>
    <div class="flex flex-col w-full items-center space-y-1">
      <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="37" height="37" rx="4" fill="#F4F4F4"/><path d="M28.8041 11C28.6218 11.0022 28.4477 11.0776 28.3204 11.2096C28.1928 11.3417 28.1225 11.5195 28.1247 11.7041V19.935L9.69999 19.9351L12.734 16.4361C12.8589 16.2968 12.9229 16.1121 12.9111 15.9243C12.8993 15.7363 12.8129 15.5612 12.6713 15.4389C12.53 15.3167 12.3456 15.2576 12.1604 15.2754C11.983 15.2929 11.8193 15.3798 11.7038 15.5172L7.66802 20.1716H7.66818C7.66112 20.1804 7.65452 20.1896 7.64792 20.1987C7.63518 20.2149 7.62305 20.2317 7.6117 20.2491C7.60939 20.2522 7.60724 20.2553 7.60494 20.2586C7.59389 20.277 7.58345 20.2961 7.57409 20.3156C7.56473 20.3337 7.55629 20.3524 7.54861 20.3713C7.54631 20.3772 7.54401 20.383 7.54186 20.3889C7.53587 20.406 7.5305 20.4232 7.52574 20.4406C7.52482 20.4433 7.5239 20.4461 7.52313 20.4489C7.51899 20.4641 7.51546 20.4795 7.51239 20.495C7.50901 20.5126 7.50625 20.5303 7.50425 20.548C7.5018 20.571 7.50042 20.5941 7.50026 20.6173C7.49965 20.6399 7.50011 20.6626 7.50164 20.6853V20.6879C7.50364 20.7103 7.50686 20.7325 7.51101 20.7546C7.53311 20.8773 7.58729 20.992 7.66818 21.0863C7.67554 21.095 7.68307 21.1035 7.69089 21.1121L11.7038 25.7405V25.7404C11.8217 25.8886 11.9941 25.9813 12.1813 25.9975C12.3684 26.0136 12.5538 25.9517 12.6947 25.8258C12.8355 25.7 12.9193 25.5215 12.9268 25.3315C12.9342 25.1415 12.8645 24.9568 12.734 24.8202L9.70542 21.327H28.815C28.9973 21.3262 29.172 21.2521 29.3004 21.1211C29.4289 20.99 29.5006 20.8127 29.5 20.6282V11.7041C29.5021 11.5167 29.4295 11.3364 29.2986 11.2039C29.1677 11.0714 28.9895 10.9979 28.8042 11L28.8041 11Z" fill="#444C58"/></svg>
      <span class="font-[Inter] italic font-normal text-xs text-[#073B5D]">during edit mode</span>
      <span class="font-[Inter] font-semibold text-sm text-[#2A8176]">Exit edit mode</span>
    </div>
  </div>
`

const jobTrackerOnBoardingSort = () => `
     <div class="flex items-center">
         <p class="whitespace-nowrap">Use the</p>
         <svg width="20" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.83312 3.74033C4.17978 5.46699 6.66645 8.66699 6.66645 8.66699V12.667C6.66645 13.0337 6.96645 13.3337 7.33312 13.3337H8.66645C9.03312 13.3337 9.33312 13.0337 9.33312 12.667V8.66699C9.33312 8.66699 11.8131 5.46699 13.1598 3.74033C13.4998 3.30033 13.1865 2.66699 12.6331 2.66699H3.35978C2.80645 2.66699 2.49312 3.30033 2.83312 3.74033Z" fill="#C2C4C6"/>
        </svg>
         <p class="whitespace-nowrap">icon in each column to filter and</p>
        <svg width="20" class="icon" viewBox="0 0 16 16">
            <path d="M13.3333 7.99967L12.3933 7.05967L8.66666 10.7797V2.66634H7.33333L7.33333 10.7797L3.61333 7.05301L2.66666 7.99967L8 13.333L13.3333 7.99967Z" fill="#929497"/>
        </svg>
          <span class=""> to sort</span>
    </div>
     <p>your table.</p>
`   
 
// adding onboarding steps 
export const networkOnboarding = () => [
{
  element: document.querySelector('#networking-form'),
  position: 'right',
  intro: buildStep(1,
    'Select your networking goal',
    'Choose the option that matches your goals. But don’t worry! You can change these settings later.',
  ),
},
{
  element: document.querySelector('#networking-selected-form'),
  position: 'left',
  intro: buildStep(2,
    'Fill in all fields with your info',
    'For best results, make sure to complete each field. No skipping!',
  ),
},
{
  element: document.querySelector('.pencil-edit'),
  position: 'left',
  intro: buildStep(3,
    'Make your changes',
    `<div class="flex flex-wrap text-sm won-blue">
      Click on
      <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
          Edit <svg class="ml-0.5 w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M3 17.2505V21.0005H6.75L17.81 9.94055L14.06 6.19055L3 17.2505ZM20.71 7.04055C21.1 6.65055 21.1 6.02055 20.71 5.63055L18.37 3.29055C17.98 2.90055 17.35 2.90055 16.96 3.29055L15.13 5.12055L18.88 8.87055L20.71 7.04055Z" fill="#656E83" /> </svg>
      </span>
      to change your message.
  </div> `
  ),
},
{
  element: document.querySelector('.pencil-copy'),
  position: 'left',
  intro: buildStep(4,
    'Get your message',
    `<div class="flex flex-wrap text-sm won-blue">
      Click on
      <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
          Copy <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_764_32923)"> <path d="M10.6666 0.666656L2.66659 0.666656C1.93325 0.666656 1.33325 1.26666 1.33325 1.99999L1.33325 11.3333H2.66659L2.66659 1.99999L10.6666 1.99999V0.666656ZM12.6666 3.33332L5.33325 3.33332C4.59992 3.33332 3.99992 3.93332 3.99992 4.66666L3.99992 14C3.99992 14.7333 4.59992 15.3333 5.33325 15.3333L12.6666 15.3333C13.3999 15.3333 13.9999 14.7333 13.9999 14L13.9999 4.66666C13.9999 3.93332 13.3999 3.33332 12.6666 3.33332ZM12.6666 14L5.33325 14L5.33325 4.66666L12.6666 4.66666L12.6666 14Z" fill="#A1AEB7"/> </g> <defs> <clipPath id="clip0_764_32923"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg> 
      </span>
      to copy your message.
  </div> `
  ),
},
{
  element: document.querySelector('.pencil-favorite'),
  position: 'left',
  intro: buildStep(5,
    'Save your message',
    `<div class="flex flex-wrap text-sm won-blue">
      Click on
      <span class="flex items-center px-1 rounded-md won-tag-light-gray mx-1">
          Favorite <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_764_33420)"> <path d="M11.0002 2C9.84016 2 8.72683 2.54 8.00016 3.39333C7.2735 2.54 6.16016 2 5.00016 2C2.94683 2 1.3335 3.61333 1.3335 5.66667C1.3335 8.18667 3.60016 10.24 7.0335 13.36L8.00016 14.2333L8.96683 13.3533C12.4002 10.24 14.6668 8.18667 14.6668 5.66667C14.6668 3.61333 13.0535 2 11.0002 2ZM8.06683 12.3667L8.00016 12.4333L7.9335 12.3667C4.76016 9.49333 2.66683 7.59333 2.66683 5.66667C2.66683 4.33333 3.66683 3.33333 5.00016 3.33333C6.02683 3.33333 7.02683 3.99333 7.38016 4.90667H8.62683C8.9735 3.99333 9.9735 3.33333 11.0002 3.33333C12.3335 3.33333 13.3335 4.33333 13.3335 5.66667C13.3335 7.59333 11.2402 9.49333 8.06683 12.3667Z" fill="#A1AEB7"/> </g> <defs> <clipPath id="clip0_764_33420"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg> 
      </span>
      to mark and save your message.
  </div> `
  ),
},
{
  element: document.querySelector('.goto-linkedin'),
  position: 'left',
  intro: buildStep(6,
    'Start networking',
    `Click on <b>“Go to LinkedIn”</b> button to go directly to your LinkedIn account to connect with recruiters and others.`
  ),
},
{
  element: document.querySelector('.how-it-works'),
  position: 'left',
  intro: buildStep(7,
    'Learn more about networking',
    `Click on <b>“How it Works”</b> to watch a tutorial.`
  ),
},
{
  element: document.querySelector('.favorites'),
  position: 'left',
  intro: buildStep(8,
    'See all of your messages',
    `Click on <b>“Favorites”</b> to see your saved messages and all of your generations.`
  ),
},
]


export const ColdEmailOnboarding = () => [
{
  element: document.querySelector('#networking-form'),
  position: 'right',
  intro: buildStep(1,
    'Get started with Email Finder',
    'Find emails of top executives, hiring managers and recruiters at your target companies! For best results, make sure to complete each field. No skipping!',
  ),
},
{
  element: document.querySelector('#networking-selected-form'),
  position: 'left',
  intro: buildStep(2,
    'Get started with Email Finder',
    'Find emails of top executives, hiring managers and recruiters at your target companies! For best results, make sure to complete each field. No skipping!',
  ),
},
{
  element: document.querySelector('.select-your-email'),
  position: 'left',
  intro: buildStep(3,
    'Select an email address ',
    ` Select the email address you want to send an email to, the higher the relevancy score, the better the chances you cold email will be successful.`
  ),
},{
  element: document.querySelector('#cold-email-selected-form'),
  position: 'right',
  intro: buildStep(4,
    'Use the email generator',
    'Select your resume and add key points to generate a cold email to send to your previous generated email address.',
  ),
},{
  element: document.querySelector('.cold-email-generated-results'),
  position: 'left',
  intro: buildStep(5,
    'Copy your generated email!',
    'Copy your email address, title and content and go to your email provider to send it!',
  ),
}

]

export const resumeOnboarding = (changeFirst = false) => [
!changeFirst ?
  {
    element: document.querySelector('#resume-form'),
    position: 'right',
    intro: buildStep(1,
      'Answer these questions',
      'This will give our tool exactly what it needs to generate your perfect resume bullet points. The more effort you put into your answers, the better the results!',
    ),
  } :
  {
    element: document.querySelector('#resume-form-points'),
    position: 'right',
    intro: buildStep(1,
      'Enter an old resume point.',
      'Paste an old resume point here and we\'ll take it to the next level to help you land your dream job.',
    ),
  },
{
  element: document.querySelector('#resume-card-onboarding-first-actions'),
  position: 'left',
  intro: buildStep(2,
    'Refine your bullet points.',
    actionMessage('<span class="mr-1">bullet</span><span class="mr-1">points</span>'),
  ),
},
]

export const tokensOnboarding = () => [
{
  element: document.querySelector('#sidebar-tokens-container'),
  position: 'right',
  intro: buildStep(0,
    'Your Token Counter.',
    purchaseMessage(),
  ),
}
]

export const builderOnboarding = () => [
  {
    element: document.querySelector('#onboarding-builder-textarea'),
    position: 'bottom',
    intro: buildStep(1,
      'Add bullet points',
      `Hover over bullet points to see this: Click ${editAction()} or double click to type in your own bullet points, or click ${generatePointsAction()} to use the Bullet Point Generator.`
    ),
  },
  {
    element: document.querySelector('#onboarding-generator-points'),
    position: 'right',
    intro: buildStep(2,
      'Describe your experience',
      `Answer a few questions to generate personalized bullet points. Regenerate until you found your perfect points and add them to your resume with the ${addBulletPointAction()} icon.`,
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-section-header'),
    position: 'bottom',
    intro: buildStep(3,
      'Edit your sections',
      `${editAction()} or double click to type in personalized information, ${removeAction()} sections you don’t need, ${reorderAction()} sections by dragging, and ${addAction()} content to include more schools, experiences, etc.`,
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-add-section'),
    position: 'top',
    intro: buildStep(4,
      'Add sections',
      'You can add new sections with this button!',
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-style-builder'),
    position: 'bottom',
    intro: buildStep(5,
      'Text Editor',
      'Use our text editor to format your text however you like! Add hyperlinks on your resume for your Linkedin, portfolios, or personal websites. ',
    ),
  },
  {
    element: document.querySelector('#pdf-ruler'),
    position: 'bottom',
    intro: buildStep(6,
      'Format your page',
      'Change your margins by dragging these green arrows. You can always reset your margin changes and go back to the default layout using the reset button.',
    ),
  },
  {
    intro: buildStep(7,
      'Keyboard Commands',
      `${keyboardCommandsAction()}`,
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-download'),
    position: 'left',
    intro: buildStep(8,
      'Download your resume',
      'Once you’re happy with your resume, download it as a PDF or DOCX file and you’re all set!',
    ),
  },
]

export const coverletterOnboarding = () => [
  {
    element: document.querySelector('#onboarding-select-resume'),
    position: 'right',
    intro: buildStep(1,
      'Select a resume from ResumAI',
      `You can select any resume you have created on our platform for best results, however, you can also upload a resume or start without one.`
    ),
  },
  {
    element: document.querySelector('#onboarding-select-resume-step2'),
    position: 'right',
    intro: buildStep(2,
      'Review all fields with your info',
      `These fields were all imported from your resume, please review or modify them and click generate.`,
    ),
  },
  {
    element: document.querySelector('.builder-content'),
    position: 'bottom',
    intro: buildStep(3,
      'Customize your cover letter!',
      `You can adjust the generated cover letter as you wish, this document is all yours to use, you can edit the text or copy it, add the name of the file and more!`,
    ),
  },
  {
    element: document.querySelector('#onboarding-cover-letter-reset-generation'),
    position: 'bottom',
    intro: buildStep(4,
      'Regenerate your cover letter',
      'There is an option to regenerate your cover letter if you wish to do so, this will create another document.',
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-style-builder'),
    position: 'bottom',
    intro: buildStep(5,
      'Text Editor',
      'Use our text editor to format your text however you like! Add hyperlinks on your resume for your Linkedin, portfolios, or personal websites. ',
    ),
  },
  {
    element: document.querySelector('#pdf-ruler'),
    position: 'bottom',
    intro: buildStep(6,
      'Format your page',
      'Change your margins by dragging these green arrows. You can always reset your margin changes and go back to the default layout using the reset button.',
    ),
  },
  {
    intro: buildStep(7,
      'Keyboard Commands',
      `${keyboardCommandsAction()}`,
    ),
  },
  {
    element: document.querySelector('#onboarding-builder-download'),
    position: 'left',
    intro: buildStep(8,
      'Download your cover letter',
      'Once you’re happy with your cover letter, copy or download it as a PDF or DOCX file and you’re all set!',
    ),
  },
]

export const dashboardOnboarding = () => [
  {
    element: document.querySelector('.tools-div'),
    position: 'right',
    intro: buildStep(1,
      'Know what you need to do?',
      'Updating your resume? Looking for interview help? If you know exactly what you want to do, get started right away with the right tool.'
    ),
  },
  {
    element: document.querySelector('.current-stage-job-search-plan'),
    position: 'left',
    intro: buildStep(2,
      'Not sure where to start?',
      'If you want some guidance, check out our step-by-step plan, based on Jerry and Jon’s job search best practices!'
    ),
  },
  {
    element: document.querySelector('.job-search-plan-learn-more'),
    position: 'left',
    intro: buildStep(3,
      'A couple of tips',
      'Navigate to other stages to get sneak peeks or reminders of what you need to do!  And check out the explanations of each stage for even more help.'
    ),
  },
  {
    element: document.querySelector('.job-tracker-menu-item'),
    position: 'right',
    intro: buildStep(4,
      'Kickstart your job search',
      'You can go straight to your next step by clicking the button at the bottom of each stage.  Bonus hint: you can also see your important metrics too!'
    ),
  },
];

export const autoApplyOnboarding = () => [
    {
        element: document.getElementById('job-table-tabs'),
        position: 'bottom',
        intro: buildStep(1,
            'Table Tabs',
            `Your Job Table has two tabs: Available Jobs and Applied Jobs. View your Available Jobs tab to apply to jobs that we recommend for you. View your Applied Jobs tab to keep track of what jobs you have applied to using AutoApplyAI and their status.`
        ),
    },
    {
        element: document.getElementById('table-filters'),
        position: 'right',
        intro: buildStep(2,
            'Filter and sort the job table',
            `Use the icons in each column to filter and sort through your table.`
        ),
    },
    {
        element: document.getElementById('job-apply-checkbox'),
        position: 'right',
        intro: buildStep(3,
          'Apply to a job',
          `Check off the checkbox of your desired job posting and click “Apply” in the top right corner.`
        ),
    },
    {
        element: document.getElementById('job-apply-checkbox'),
        position: 'right',
        intro: buildStep(4,
            'Apply to multiple jobs at once',
            `Check off the checkbox at the top of the table to select all jobs in this page of your table. Then click “Apply” in the top right corner. You can only apply to multiple jobs using Autopilot, so make sure your Autopilot mode is ON!`
        ),
    },
    {
        element: document.getElementById('jobs-table-resume'),
        position: 'left',
        intro: buildStep(5,
          'Change Resume',
          `Before you apply, make sure you are applying with your desired resume. To change the resume you want to apply with, click the Resume Link.`,
        ),
    },
]

export const autoApplyDashboardOnboarding = () => [
    {
        element: document.getElementById('find-jobs-button'),
        position: 'right',
        intro: buildStep(1,
            'Start Applying',
            `Let us help you find jobs to apply to by clicking “Find Jobs”.`
        ),
    },
    {
        element: document.getElementById('your-activity'),
        position: 'left',
        intro: buildStep(2,
            'Your Activity',
            `We track your activity to help you refine your applications and yield the best results!`,
        ),
    },
    {
        element: document.getElementById('settings-aa'),
        position: 'right',
        intro: buildStep(3,
            'Change application info',
            `You can change any application information in your WonsultingAI settings`,
        ),
    },
    {
        element: document.getElementById('job-tracker-aa'),
        position: 'left',
        intro: buildStep(4,
            'Job Status Tracker',
            `Track the status of your applications in one place by connecting your Gmail Account to AutoApplyAI. We will be using job related emails only and you can always disconnect in Settings.`,
        ),
    },
]

export const interviewProcessOnboarding = () => [
  {
    element: document.getElementById('interview-questions'),
    position: 'left',
    intro: buildStep(1,
      'Answer the interview questions',
      `Wait for the interviewer to dictate the questions - once they finish speaking, you can answer. You may also get follow up questions to answer!`
    ),
  },
  {
    element: document.getElementById('skip-question'),
    position: 'left',
    intro: buildStep(2,
      'After you answer your question',
      `Wait 3 seconds without speaking to move onto the next question - otherwise, click on the "Skip Question" button to continue on or skip the question if you want!`
    ),
  },
  {
    element: document.getElementById('stop-interview'),
    position: 'right',
    intro: buildStep(3,
      'Keep track of your interviews',
      `Click here to stop your interview and save your progress. Your interviews are recorded and will be accessible from the dashboard, but consider finishing them out in one go to master your interview skills!`,
    ),
  }
]

export const interviewAiProcessOnboarding = () => [
  {
    element: document.getElementById('create-new-interview'),
    position: 'right',
    intro: buildStep(1,
      'Start your new interview',
      `You can start your first interview and start improving your skills. You can add the job you want to practice for manually`
    ),
  },
  {
    element: document.getElementById('progress-chart'),
    position: 'top',
    intro: buildStep(2,
      'Track your progress',
      `Build confidence and tame your interview anxiety with measurable feedback and consistent growth.`
    ),
  },
  {
    element: document.getElementById('user-stats'),
    position: 'right',
    intro: buildStep(3,
      'Total scoring system',
      `Take the guesswork out of your interview performance. InterviewAI scores your mock interviews based on three criteria: Speech, content, and non-verbals. Keep testing and improving!`,
    ),
  },
  {
    element: document.getElementById('completed-interviews'),
    position: 'top',
    intro: buildStep(2,
      'Track your progress',
      `Build confidence and tame your interview anxiety with measurable feedback and consistent growth.`
    ),
  }
]

export const jobTrackerOnboarding = () => [
  {
    element: document.getElementById('table-filters'),
    position: 'bottom',
    intro: buildStep(1,
      'Filter and sort the job table',
      `${jobTrackerOnBoardingSort()}`
    ),
  },
  {
    element: document.getElementById('data-management'),
    position: 'bottom',
    intro: buildStep(2,
      'Manage your data ',
      `View and manage the data we collected from your emails to fine-tune job applications, interview invitations, and job offers.`
    ),
  },
]

